module.exports = __webpack_public_path__ + "static/media/contatos.66f1cb43.svg";